import {
    Box, Button, Container, Divider, HStack, Heading, Image,
    Link,
    Stack, Text, useBreakpointValue,
} from '@chakra-ui/react';
import { accreditationLogos } from '@acp/core-ui/assets';
import { SocialIcons } from './social-icons';
import { SiteNavLinks } from './site-nav-links';
import { DiLogo, LogoVariant } from '../di-logo';

export function AppFooter() {
    const currentYear = new Date().getFullYear();
    const businessContact = '1300 134 563';
    const electricalLicenses = {
        vic: 'VIC REC 30673',
        qld: 'QLD 87100',
        nsw: 'NSW 372889C',
        tas: 'TAS 15608738',
        sa: 'SA PGE325526',
    };

    const isContentCentered = useBreakpointValue({ base: true, md: false });
    const diLogo = useBreakpointValue({
        base: 'stackedRGBWhite',
        md: 'horizontalRGBWhite',
    }) as LogoVariant;

    return (
        <Box bgColor="charcoal.900" py={10} width="full" mt="auto">
            <Container color="white" centerContent={isContentCentered} maxW={{ base: '100vw', md: '92vw', xl: '80em' }}>
                <Stack
                    direction={{ base: 'column', md: 'row', xl: 'row' }}
                    alignItems={{ base: 'center', md: 'space-between' }}
                    justifyContent={{ base: 'center', md: 'space-between' }}
                    spacing={{ base: 8, md: 5, xl: 20 }}
                >
                    <DiLogo variant={diLogo} width={{ base: '200px', md: '250px' }} />
                    <Stack
                        direction={{ base: 'column', xl: 'row' }}
                        spacing={{ base: 8, md: 5, xl: 20 }}
                        alignItems={{ base: 'center', md: 'flex-end', xl: 'initial' }}
                    >
                        <HStack spacing={10} color="muted.500" fontSize="xl">
                            <SocialIcons />
                        </HStack>
                        <HStack>
                            <Heading
                                variant="circular"
                                fontSize="1.5rem"
                                noOfLines={1}
                                color="primary.400"
                            >
                                {businessContact}
                            </Heading>
                        </HStack>
                        <HStack>
                            <Link href="https://help.detectorinspector.com.au/hc/en-au" isExternal>
                                <Button
                                    size="lg"
                                    fontSize="md"
                                    variant="rounded-solid"
                                    backgroundColor="white"
                                    color="black"
                                    _hover={{
                                        backgroundColor: 'black',
                                        color: 'white',
                                    }}
                                    colorScheme="white"
                                >
                                    Visit Help Centre
                                </Button>
                            </Link>
                        </HStack>

                    </Stack>
                </Stack>
                <Divider my={8} />
                <Stack
                    direction={{ base: 'column', lg: 'row' }}
                    alignItems={{ base: 'center', lg: 'flex-start' }}
                    justifyContent="space-between"
                >
                    <Stack
                        direction="column"
                        alignItems={{ base: 'center', lg: 'flex-start' }}
                        spacing={6}
                        fontSize="sm"
                        color="muted.500"
                    >
                        <Stack
                            direction={{ base: 'column', lg: 'row' }}
                            textAlign="center"
                        >
                            <Text>
                                &copy;
                                {' '}
                                {currentYear}
                                {' '}
                                Detector Inspector
                            </Text>
                            <SiteNavLinks />
                        </Stack>
                        <Stack
                            direction={{ base: 'column', lg: 'row' }}
                            textAlign="center"
                        >
                            <Text>Electrical Licenses:</Text>
                            <Text>
                                {`${electricalLicenses.vic} | `}
                                {`${electricalLicenses.qld} | `}
                                {`${electricalLicenses.nsw} | `}
                                {`${electricalLicenses.tas} | `}
                                {`${electricalLicenses.sa}`}
                            </Text>
                        </Stack>
                    </Stack>
                    <HStack spacing={6}>
                        <Image width="80px" src={accreditationLogos.fpaGoldMember} />
                        <Image width="80px" src={accreditationLogos.bronzeMasterElectrician} />
                    </HStack>
                </Stack>
            </Container>
        </Box>
    );
}
